import { createFileRoute } from '@tanstack/react-router';

import { requireOwnerOrAdmin } from '~/lib/route-auth';
import { AuditViewerComponent } from '~/page-components/audit-viewer';

export const Route = createFileRoute('/settings/audit')({
  beforeLoad: async () => {
    await requireOwnerOrAdmin('/settings');
  },
  component: AuditViewerComponent
});
